const NAME = "ACCOUNTING_IMPUTATIONS";

export default NAME;
